export enum GroupingTypesEnum {
    Tab = "tab",
    Section = "section",
    Subsection = "subsection"
}
